import React, { useEffect, useState, useCallback, useMemo } from 'react';
import axios from 'axios';
import dayjs from 'dayjs';
import LoadingSpinner from "../components/LoadingSpinner";

const PAGE_SIZE = 10;

const Superadmincredit = () => {
  const [data, setData] = useState([]);
  const [pageIndex, setPageIndex] = useState(1);
  const [partnerCode, setPartnerCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [filterType, setFilterType] = useState('both'); // 'credit', 'refund', or 'both'

  // Initialize with default dates
  const getDefaultDates = () => {
    const today = dayjs();
    const fromDate = today.subtract(8, 'day');
    return {
      from: fromDate.format('YYYY-MM-DD'),
      to: today.format('YYYY-MM-DD'),
    };
  };

  const { from: defaultFrom, to: defaultTo } = getDefaultDates();
  const [fromDate, setFromDate] = useState(defaultFrom);
  const [toDate, setToDate] = useState(defaultTo);

  const token = localStorage.getItem("token");

  const fetchData = useCallback(async () => {
    const apiUrl = process.env.REACT_APP_BASE_URL;

    if (!fromDate || !toDate) return;

    setLoading(true);
    try {
      const response = await axios.post(`${apiUrl}Renew/GetNewWallet`, {
        pageIndex: 1,
        pageSize: 300,
        fromDate,
        toDate,
        partnerCode: 0,
        countryCode: '',
        creditOrRefund: 1,
      }, {
        headers: {
          'accept': '*/*',
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        }
      });

      const resData = response.data;
      if (resData.isSuccess) {
        const walletData = resData.getwallet || [];

        // Filter only Credit and Refund types
        const creditRefundData = walletData.filter(
          (item) => 
            item.type?.toLowerCase() === 'credit' || 
            item.type?.toLowerCase() === 'refund'
        );

        setData(creditRefundData);
      }
    } catch (error) {
      console.error('API error:', error);
    } finally {
      setLoading(false);
    }
  }, [fromDate, toDate, partnerCode, token]);

  // Fetch data on initial mount
  useEffect(() => {
    fetchData();
  }, [fetchData]);
const getUpdatedByName = (updatedBy) => {
  if (updatedBy == 141) return 'Rajesh';
  if (updatedBy == 129) return 'Ashish';
  if (updatedBy == "") return 'Stripe';

  return updatedBy; // fallback if unknown
};

  // Filter data based on selected type
  const filteredData = useMemo(() => {
    if (filterType === 'both') {
      return data;
    }
    return data.filter(
      (item) => item.type?.toLowerCase() === filterType.toLowerCase()
    );
  }, [data, filterType]);

  // Paginated data
  const paginatedData = useMemo(() => {
    const startIndex = (pageIndex - 1) * PAGE_SIZE;
    const endIndex = startIndex + PAGE_SIZE;
    return filteredData.slice(startIndex, endIndex);
  }, [filteredData, pageIndex]);

  const totalCount = filteredData.length;
  const totalPages = Math.ceil(totalCount / PAGE_SIZE) || 1;

  // Reset to page 1 when filter changes
  useEffect(() => {
    setPageIndex(1);
  }, [filterType]);

  const handleSearch = () => {
    setPageIndex(1);
    fetchData();
  };

  // Handle filter type change
  const handleFilterChange = (e) => {
    setFilterType(e.target.value);
    setPageIndex(1); // Reset to first page when filter changes
  };

  return (
    <div className="max-w-6xl mx-auto p-2">
      <h1 className="text-2xl font-semibold mb-2">Wallet History</h1>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 mb-6">
        <input
          type="text"
          placeholder="Search Partner Code"
          className="border border-gray-300 rounded px-4 py-2"
          value={partnerCode}
          onChange={(e) => setPartnerCode(e.target.value)}
        />

        <input
          type="date"
          className="border border-gray-300 rounded px-4 py-2"
          value={fromDate}
          onChange={(e) => setFromDate(e.target.value)}
        />

        <input
          type="date"
          className="border border-gray-300 rounded px-4 py-2"
          value={toDate}
          onChange={(e) => setToDate(e.target.value)}
        />

        {/* Filter Dropdown for Credit/Refund */}
        <select
          className="border border-gray-300 rounded px-4 py-2 bg-white"
          value={filterType}
          onChange={handleFilterChange}
        >
          <option value="both">Both (Credit & Refund)</option>
          <option value="credit">Credit Only</option>
          <option value="refund">Refund Only</option>
        </select>

        <button
          onClick={handleSearch}
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
        >
          Search
        </button>
      </div>

     

      {loading ? (
        <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-50">
          <LoadingSpinner />
        </div>
      ) : (
        <div className="overflow-x-auto">
          <table className="min-w-full bg-white border rounded shadow-sm">
            <thead>
              <tr className="bg-gray-100 text-gray-700">
                <th className="py-2 px-4 text-left">S.NO</th>
                <th className="py-2 px-4 text-left">Date_Recharge</th>
                <th className="py-2 px-4 text-left">Amount</th>
                <th className="py-2 px-4 text-left">Type</th>
                <th className="py-2 px-4 text-left">Balance</th>
                <th className="py-2 px-4 text-left">Company</th>
                {/* <th className="py-2 px-4 text-left">Email</th> */}
                <th className="py-2 px-4 text-left">Updated By</th>
                <th className='py-2 px-4 text-left'>remarkDescription</th>
              </tr>
            </thead>
            <tbody>
              {paginatedData.length > 0 ? paginatedData.map((item, index) => (
                <tr key={index} className="border-t hover:bg-gray-50">
                  <td className="py-2 px-4">
                    {(pageIndex - 1) * PAGE_SIZE + index + 1}
                  </td>
                  <td className="py-2 px-4">{item.date}</td>
                                    <td className="py-2 px-4">  ${String(item.amount).replace('$', '')}</td>

                  <td className="py-2 px-4">
                    <span className={`px-2 py-1 rounded text-sm ${
                      item.type?.toLowerCase() === 'credit' 
                        ? 'bg-green-100 text-green-800' 
                        : 'bg-blue-100 text-blue-800'
                    }`}>
                      {item.type}
                    </span>
                  </td>
                  <td className="py-2 px-4">  ${String(item.balance).replace('$', '')}</td>
                  <td className="py-2 px-4">{item.companyName}</td>
                  <td className="py-2 px-4">{getUpdatedByName(item.updatedBy)}</td>
                  <td className="py-2 px-4">{item.remarkDescription||"NA"}</td>
                </tr>
              )) : (
                <tr>
                  <td colSpan="8" className="text-center py-4 text-gray-500">
                    No data found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {/* Pagination */}
      <div className="flex justify-between items-center mt-6">
        <button
          onClick={() => setPageIndex((prev) => Math.max(prev - 1, 1))}
          disabled={pageIndex === 1}
          className="px-3 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
        >
          Previous
        </button>

        <div className="flex items-center gap-2">
          <span className="text-gray-700">
            Page {pageIndex} of {totalPages}
          </span>
          
          {/* Optional: Page number buttons */}
          <div className="flex gap-1 ml-4">
            {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
              let pageNum;
              if (totalPages <= 5) {
                pageNum = i + 1;
              } else if (pageIndex <= 3) {
                pageNum = i + 1;
              } else if (pageIndex >= totalPages - 2) {
                pageNum = totalPages - 4 + i;
              } else {
                pageNum = pageIndex - 2 + i;
              }
              
              return (
                <button
                  key={pageNum}
                  onClick={() => setPageIndex(pageNum)}
                  className={`px-3 py-1 rounded ${
                    pageIndex === pageNum 
                      ? 'bg-blue-600 text-white' 
                      : 'bg-gray-200 hover:bg-gray-300'
                  }`}
                >
                  {pageNum}
                </button>
              );
            })}
          </div>
        </div>

        <button
          onClick={() => setPageIndex((prev) => Math.min(prev + 1, totalPages))}
          disabled={pageIndex === totalPages}
          className="px-3 py-2 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
        >
          Next
        </button>
      </div>
    </div>
  );
};

export default Superadmincredit;